import { render, staticRenderFns } from "./FuncionalidadeCustomizada.vue?vue&type=template&id=865b9332"
import script from "./FuncionalidadeCustomizada.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeCustomizada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports